/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneYoutube from 'base/components/standalone/Youtube';

export const DynamicStandaloneYoutube = StandaloneYoutube;
export type DynamicStandaloneYoutubeProps = PropsFromComponent<typeof StandaloneYoutube>;

export const DynamicStandaloneYoutubeWith = (extras: DynamicStandaloneExtras): typeof StandaloneYoutube => {
    return function DynamicStandaloneYoutube(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Youtube');
        return <StandaloneYoutube {...mergeProps({ options: { theme } }, props)} />;
    }
}